export default "__VITE_ASSET__79a9ab60__"